import React, { Component } from 'react';
import Teaser from '../details/Teaser';
import Slideshow from '../details/views/Slideshow';
import styles from './river.module.scss';
import { CSSPlugin } from 'gsap/CSSPlugin';

import { TimelineLite, TweenLite } from 'gsap';
// import { ThrowPropsPlugin } from '../../../lib/ThrowPropsPlugin';

let Draggable;
let ThrowPropsPlugin;
const plugins = [CSSPlugin];
const inDelay = 0.75;
const outDelay = 0.75;
const headerHeight = parseInt(
  styles.locationHeaderHeight.replace('px', ''),
  10
);

const setBodyColor = color => {
  if (typeof document !== undefined) {
    let body = document.querySelector('body');
    body.style.backgroundColor = color;
  }
};

class River extends Component {
  state = {
    currentStop: undefined,
    nextStop: undefined,
  };

  initSwipe = () => {
    if (typeof window !== undefined && typeof document !== undefined) {
      Draggable = require('gsap/Draggable');
      ThrowPropsPlugin = require('../../../lib/ThrowPropsPlugin');
      let riverHeight = this.riverRef.getBoundingClientRect().height;

      let direction;
      let _river = this.riverRef;
      this.swipe = Draggable.create(this.riverRef, {
        type: 'y',
        trigger: this.headerRef,
        lockAxis: 'y',
        throwProps: true,
        bounds: {
          top: 0,
          left: 0,
          width: 0,
          height: riverHeight * 2 - headerHeight,
        },
        overshootTolerance: 0.15,
        onDragEnd: function() {
          //move the original marker to end position
          if (this.getDirection('velocity') === 'up') {
            TweenLite.to(_river, 0.68, {
              x: this.x,
              y: this.minY,
              onComplete: setBodyColor,
              onCompleteParams: ['#fff'],
              force3D: true,
            });
          } else if (this.getDirection('velocity') === 'down') {
            TweenLite.to(_river, 0.68, {
              x: this.x,
              y: this.maxY,
              onComplete: setBodyColor,
              onCompleteParams: [''],
              force3D: true,
            });
          }
        },
      });

      window.addEventListener('resize', () => {
        if (!this.swipe[0].enabled()) return;
        riverHeight = this.riverRef.getBoundingClientRect().height;
        this.swipe[0].applyBounds({
          top: 0,
          left: 10,
          width: 0,
          height: riverHeight * 2 - headerHeight,
        });
      });
    }
  };

  toggleSwipe = () => {
    if (this.props.isMobileDevice && this.riverRef) {
      this.swipe[0].enable();
    } else {
      this.swipe[0].disable();
    }
  };

  animateMaskIn = (title, delay = 0) => {
    return TweenLite.to(title, 0.85, {
      autoAlpha: 1,
      y: '0%',
      ease: Quint.easeInOut,
      delay: delay,
      force3D: true,
    });
  };

  animateFadeIn = (content, delay = 0) => {
    return TweenLite.to(content, 0.85, {
      autoAlpha: 1,
      ease: Quint.easeInOut,
      delay: delay,
      force3D: true,
    });
  };

  animateOff = () => {};

  animateOnMount = () => {
    const { isMobileDevice } = this.props;
    const riverHeight = this.riverRef.getBoundingClientRect().height;
    let fromY = isMobileDevice ? riverHeight : 50;
    let toY = isMobileDevice ? riverHeight - headerHeight : 0;

    TweenLite.set(this.riverRef, {
      autoAlpha: 0,
      y: fromY,
    });

    const onMountTimeline = new TimelineLite({
      clearProps: 'all',
      force3D: true,
      onComplete: () => {
        this.initSwipe();
        this.props.setIsTransitioningBetweenStops(false);
        this.toggleSwipe();
      },
    });

    onMountTimeline
      .to(
        this.riverRef,
        0.85,
        {
          autoAlpha: 1,
          y: toY,
          ease: Quad.easeOut,
        },
        0
      )
      .add(this.animateMaskIn(this.titleRef, inDelay), 0);
  };

  animateNextIn = () => {
    const nextInTimeline = new TimelineLite({
      clearProps: 'all',
      force3D: true,
      onComplete: () => {
        this.props.setIsTransitioningBetweenStops(false);
      },
    });

    nextInTimeline
      .add(this.animateMaskIn(this.titleRef), 0)
      .add(this.animateFadeIn(this.contentRef), 0)
      .add(this.animateFadeIn(this.scrimRef), 0);
  };

  animateToNextOut = () => {
    const totalDuration = 1.25;
    TweenLite.set(this.bgRef, { x: '-50%' });
    TweenLite.set(this.nextBgRef, { x: '50%' });

    const nextOutTimeline = new TimelineLite({
      clearProps: 'all',
      force3D: true,
      onStart: () => {
        this.props.setIsTransitioningBetweenStops(true);
      },
      onComplete: () => {
        TweenLite.set(this.contentRef, { scrollTop: 0 });
        this.setState({ currentStop: this.state.nextStop }, () => {
          this.animateNextIn();
        });
      },
    });

    nextOutTimeline
      .to(
        this.bgRef,
        totalDuration,
        {
          x: '-150%',
          ease: Quint.easeInOut,
          onComplete: this.onComplete,
        },
        0
      )
      .to(
        this.nextBgRef,
        totalDuration,
        {
          x: '-50%',
          ease: Quint.easeInOut,
        },
        0
      )
      .to(
        this.titleRef,
        totalDuration * 0.85,
        {
          y: '110%',
          ease: Quint.easeInOut,
        },
        0
      )
      .to(
        this.contentRef,
        totalDuration,
        {
          autoAlpha: 0,
          ease: Quint.easeInOut,
        },
        0
      )
      .to(
        this.scrimRef,
        totalDuration,
        {
          autoAlpha: 0,
          ease: Quint.easeInOut,
        },
        0
      );
  };

  handAnimateNextComplete = () => {
    this.setState();
  };

  resetAllTweenedProps = () => {
    const targets = [
      this.bgRef,
      this.nextBgRef,
      this.riverRef,
      this.contentRef,
    ];
    TweenLite.killTweensOf(targets);
    TweenLite.set(targets, { clearProps: 'all' });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.activeStop !== nextProps.activeStop) {
      this.setState(
        { nextStop: nextProps.activeStop },
        this.animateToNextOut()
      );
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  componentDidUpdate(prevProps) {
    if (this.props.isMobileDevice !== prevProps.isMobileDevice) {
      this.resetAllTweenedProps();
      this.toggleSwipe();
    }
  }

  componentWillMount() {
    this.setState({
      currentStop: this.props.activeStop,
      nextStop: this.props.activeStop,
    });
  }

  componentDidMount() {
    TweenLite.set(this.titleRef, { y: '100%' });
    this.animateOnMount();
    // this.animateMaskIn(this.titleRef, inDelay);
  }

  render() {
    const {
      setActiveDetail,
      activeDetail,
      isSlideshowDetailOpen,
      handleTourStopDetailClosed,
    } = this.props;

    const { nextStop, currentStop } = this.state;
    const { title, body, details } = currentStop;
    return (
      <div className={styles.riverContainer} ref={el => (this.riverRef = el)}>
        <div className={styles.riverContainerInner}>
          <div ref={el => (this.headerRef = el)} className={styles.header}>
            <div ref={el => (this.bgRef = el)} className={styles.headerBg}>
              {currentStop.image &&
                currentStop.image.sizes && (
                  <img
                    className={styles.headerBgImage}
                    src={currentStop.image.sizes.large}
                    alt={currentStop.image.alt}
                  />
                )}
            </div>
            <div
              ref={el => (this.nextBgRef = el)}
              className={styles.nextHeaderBg}
            >
              {nextStop.image &&
                nextStop.image.sizes && (
                  <img
                    className={styles.headerBgImage}
                    src={nextStop.image.sizes.large}
                    alt={nextStop.image.alt}
                  />
                )}
            </div>
            <div className={styles.locationNameWrapper}>
              <span
                ref={el => (this.scrimRef = el)}
                className={styles.titleScrim}
              />
              <p className={styles.swipeCta}>Swipe up to explore</p>
              <div style={{ overflow: 'hidden' }}>
                <h2
                  ref={el => (this.titleRef = el)}
                  className={styles.locationName}
                  dangerouslySetInnerHTML={{ __html: currentStop.title }}
                />
              </div>
            </div>
          </div>
          <div
            ref={el => (this.contentRef = el)}
            className={styles.teaserContainer}
          >
            <div className={styles.tourStopBodyContainer}>
              <div
                className={styles.tourStopBody}
                dangerouslySetInnerHTML={{ __html: body }}
              />
            </div>
            {details !== undefined &&
              details.length > 0 &&
              details.map((detail, index) => {
                return (
                  <Teaser
                    setActiveDetail={setActiveDetail}
                    isActive={
                      activeDetail && detail.title === activeDetail.title
                    }
                    key={`${detail.detail_type}-${index}`}
                    {...detail}
                  />
                );
              })}
          </div>
          {isSlideshowDetailOpen && (
            <Slideshow
              handleTourStopDetailClosed={handleTourStopDetailClosed}
              isOpen={isSlideshowDetailOpen}
              title={isSlideshowDetailOpen && title}
              {...activeDetail}
            />
          )}
        </div>
      </div>
    );
  }
}

export default River;



// WEBPACK FOOTER //
// ./src/components/tour/river/River.js